/**
 * Smartfactor API
 * API for Smartfactor System
 *
 * The version of the OpenAPI document: 0.4.297
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryItemRead } from '../model/wasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryItemRead';
// @ts-ignore
import { WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryRead } from '../model/wasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryRead';
// @ts-ignore
import { WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryWrite } from '../model/wasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryWrite';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


export interface DeleteWasteCollectionScheduleEntryWasteCollectionScheduleEntryItemRequestParams {
    id: string;
}

export interface GetWasteCollectionScheduleEntryCollectionWasteCollectionScheduleEntryCollectionRequestParams {
    area?: string;
    area2?: Array<string>;
    collectionType?: string;
    collectionType2?: Array<string>;
    pickupDateBefore?: string;
    pickupDateStrictlyBefore?: string;
    pickupDateAfter?: string;
    pickupDateStrictlyAfter?: string;
    orderPickupDate?: string;
    orderAreaName?: string;
    /** The collection page number */
    page?: number;
    /** The number of items per page */
    itemsPerPage?: number;
    /** Enable or disable pagination */
    pagination?: boolean;
}

export interface GetWasteCollectionScheduleEntryItemWasteCollectionScheduleEntryItemRequestParams {
    id: string;
}

export interface PatchWasteCollectionScheduleEntryWasteCollectionScheduleEntryItemRequestParams {
    id: string;
    /** The updated WasteCollectionScheduleEntry resource */
    wasteCollectionScheduleEntry?: WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryWrite;
}

export interface PostWasteCollectionScheduleEntryWasteCollectionScheduleEntryCollectionRequestParams {
    /** The new WasteCollectionScheduleEntry resource */
    wasteCollectionScheduleEntry?: WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryWrite;
}


@Injectable({
  providedIn: 'root'
})
export class WasteCollectionScheduleEntryService {

    protected basePath = '/system';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
            if (firstBasePath != undefined) {
                basePath = firstBasePath;
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Removes the WasteCollectionScheduleEntry resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteWasteCollectionScheduleEntryWasteCollectionScheduleEntryItem(requestParameters?: DeleteWasteCollectionScheduleEntryWasteCollectionScheduleEntryItemRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public deleteWasteCollectionScheduleEntryWasteCollectionScheduleEntryItem(requestParameters?: DeleteWasteCollectionScheduleEntryWasteCollectionScheduleEntryItemRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public deleteWasteCollectionScheduleEntryWasteCollectionScheduleEntryItem(requestParameters?: DeleteWasteCollectionScheduleEntryWasteCollectionScheduleEntryItemRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public deleteWasteCollectionScheduleEntryWasteCollectionScheduleEntryItem(requestParameters?: DeleteWasteCollectionScheduleEntryWasteCollectionScheduleEntryItemRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteWasteCollectionScheduleEntryWasteCollectionScheduleEntryItem.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/waste_collection_schedule_entries/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves the collection of WasteCollectionScheduleEntry resources.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getWasteCollectionScheduleEntryCollectionWasteCollectionScheduleEntryCollection(requestParameters?: GetWasteCollectionScheduleEntryCollectionWasteCollectionScheduleEntryCollectionRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<Array<WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryRead>>;
    public getWasteCollectionScheduleEntryCollectionWasteCollectionScheduleEntryCollection(requestParameters?: GetWasteCollectionScheduleEntryCollectionWasteCollectionScheduleEntryCollectionRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<Array<WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryRead>>>;
    public getWasteCollectionScheduleEntryCollectionWasteCollectionScheduleEntryCollection(requestParameters?: GetWasteCollectionScheduleEntryCollectionWasteCollectionScheduleEntryCollectionRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<Array<WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryRead>>>;
    public getWasteCollectionScheduleEntryCollectionWasteCollectionScheduleEntryCollection(requestParameters?: GetWasteCollectionScheduleEntryCollectionWasteCollectionScheduleEntryCollectionRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const area = requestParameters?.area;
        const area2 = requestParameters?.area2;
        const collectionType = requestParameters?.collectionType;
        const collectionType2 = requestParameters?.collectionType2;
        const pickupDateBefore = requestParameters?.pickupDateBefore;
        const pickupDateStrictlyBefore = requestParameters?.pickupDateStrictlyBefore;
        const pickupDateAfter = requestParameters?.pickupDateAfter;
        const pickupDateStrictlyAfter = requestParameters?.pickupDateStrictlyAfter;
        const orderPickupDate = requestParameters?.orderPickupDate;
        const orderAreaName = requestParameters?.orderAreaName;
        const page = requestParameters?.page;
        const itemsPerPage = requestParameters?.itemsPerPage;
        const pagination = requestParameters?.pagination;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (area !== undefined && area !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>area, 'area');
        }
        if (area2) {
            area2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'area[]');
            })
        }
        if (collectionType !== undefined && collectionType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>collectionType, 'collectionType');
        }
        if (collectionType2) {
            collectionType2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'collectionType[]');
            })
        }
        if (pickupDateBefore !== undefined && pickupDateBefore !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pickupDateBefore, 'pickupDate[before]');
        }
        if (pickupDateStrictlyBefore !== undefined && pickupDateStrictlyBefore !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pickupDateStrictlyBefore, 'pickupDate[strictly_before]');
        }
        if (pickupDateAfter !== undefined && pickupDateAfter !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pickupDateAfter, 'pickupDate[after]');
        }
        if (pickupDateStrictlyAfter !== undefined && pickupDateStrictlyAfter !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pickupDateStrictlyAfter, 'pickupDate[strictly_after]');
        }
        if (orderPickupDate !== undefined && orderPickupDate !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>orderPickupDate, 'order[pickupDate]');
        }
        if (orderAreaName !== undefined && orderAreaName !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>orderAreaName, 'order[area.name]');
        }
        if (page !== undefined && page !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>page, 'page');
        }
        if (itemsPerPage !== undefined && itemsPerPage !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>itemsPerPage, 'itemsPerPage');
        }
        if (pagination !== undefined && pagination !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pagination, 'pagination');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/waste_collection_schedule_entries`;
        return this.httpClient.request<Array<WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryRead>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves a WasteCollectionScheduleEntry resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getWasteCollectionScheduleEntryItemWasteCollectionScheduleEntryItem(requestParameters?: GetWasteCollectionScheduleEntryItemWasteCollectionScheduleEntryItemRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryItemRead>;
    public getWasteCollectionScheduleEntryItemWasteCollectionScheduleEntryItem(requestParameters?: GetWasteCollectionScheduleEntryItemWasteCollectionScheduleEntryItemRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryItemRead>>;
    public getWasteCollectionScheduleEntryItemWasteCollectionScheduleEntryItem(requestParameters?: GetWasteCollectionScheduleEntryItemWasteCollectionScheduleEntryItemRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryItemRead>>;
    public getWasteCollectionScheduleEntryItemWasteCollectionScheduleEntryItem(requestParameters?: GetWasteCollectionScheduleEntryItemWasteCollectionScheduleEntryItemRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getWasteCollectionScheduleEntryItemWasteCollectionScheduleEntryItem.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/waste_collection_schedule_entries/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryItemRead>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates the WasteCollectionScheduleEntry resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchWasteCollectionScheduleEntryWasteCollectionScheduleEntryItem(requestParameters?: PatchWasteCollectionScheduleEntryWasteCollectionScheduleEntryItemRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryRead>;
    public patchWasteCollectionScheduleEntryWasteCollectionScheduleEntryItem(requestParameters?: PatchWasteCollectionScheduleEntryWasteCollectionScheduleEntryItemRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryRead>>;
    public patchWasteCollectionScheduleEntryWasteCollectionScheduleEntryItem(requestParameters?: PatchWasteCollectionScheduleEntryWasteCollectionScheduleEntryItemRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryRead>>;
    public patchWasteCollectionScheduleEntryWasteCollectionScheduleEntryItem(requestParameters?: PatchWasteCollectionScheduleEntryWasteCollectionScheduleEntryItemRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling patchWasteCollectionScheduleEntryWasteCollectionScheduleEntryItem.');
        }
        const wasteCollectionScheduleEntry = requestParameters?.wasteCollectionScheduleEntry;

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/merge-patch+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/waste_collection_schedule_entries/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryRead>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: wasteCollectionScheduleEntry,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a WasteCollectionScheduleEntry resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postWasteCollectionScheduleEntryWasteCollectionScheduleEntryCollection(requestParameters?: PostWasteCollectionScheduleEntryWasteCollectionScheduleEntryCollectionRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryRead>;
    public postWasteCollectionScheduleEntryWasteCollectionScheduleEntryCollection(requestParameters?: PostWasteCollectionScheduleEntryWasteCollectionScheduleEntryCollectionRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryRead>>;
    public postWasteCollectionScheduleEntryWasteCollectionScheduleEntryCollection(requestParameters?: PostWasteCollectionScheduleEntryWasteCollectionScheduleEntryCollectionRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryRead>>;
    public postWasteCollectionScheduleEntryWasteCollectionScheduleEntryCollection(requestParameters?: PostWasteCollectionScheduleEntryWasteCollectionScheduleEntryCollectionRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const wasteCollectionScheduleEntry = requestParameters?.wasteCollectionScheduleEntry;

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/ld+json',
            'text/html',
            'application/octet-stream'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/waste_collection_schedule_entries`;
        return this.httpClient.request<WasteCollectionScheduleEntryAppEntityWasteWasteCollectionScheduleEntryRead>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: wasteCollectionScheduleEntry,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
